import { render, staticRenderFns } from "./CheckListManage.vue?vue&type=template&id=2555a04c&"
import script from "./CheckListManage.vue?vue&type=script&lang=js&"
export * from "./CheckListManage.vue?vue&type=script&lang=js&"
import style0 from "./CheckListManage.vue?vue&type=style&index=0&id=2555a04c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports